var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fieldset',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('u-gosmart-card-selector-field',{attrs:{"u-go-smart-cards":_vm.uGoSmartCards,"u-temp-user":_vm.tempUser,"u-pass-cert":_vm.passCert},on:{"input":_vm.select}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }